import _ from 'lodash';
import React from 'react';
import {
  FormField,
  HelpBlock,
  InputText,
  Label,
  Row,
} from '../../common/form';
import FundContext from './context';

export default function withNameInput(name, label, disabled) {
  const kebab = _.kebabCase(name);
  const capitalize = _.capitalize(name);
  const snake = _.snakeCase(name);

  function PlainInput() {
    const { state, dispatch } = React.useContext(FundContext);

    const handleChange = e => {
      const v = _.get(e, 'target.value', '');
      dispatch({ type: `set${capitalize}`, payload: v });
    };

    return (
      <Row>
        <Label htmlFor={kebab}>{label || name}</Label>
        <FormField>
          <InputText
            id={kebab}
            type="text"
            name={name}
            value={state.fund[name] || ''}
            onChange={disabled ? null : handleChange}
            disabled={disabled}
          />
          {state.errors[snake] && <HelpBlock>{state.errors[snake]}</HelpBlock>}
        </FormField>
      </Row>
    );
  }

  PlainInput.displayName = capitalize;

  return PlainInput;
}
